import React, { FC } from 'react'
import projectstart from '../../assets/svg/project-start1.svg'
import partnerImage from '../../assets/svg/partner-rainbow.svg'
import { useTranslation, Trans } from '../../plugins/i18next/ea-react-i18next';
import Button from '../Start/Button';

const BecomePartnerContent: FC = () => {

    const { t } = useTranslation("components", { keyPrefix: 'partner.becomeAPartner' });

    return (
        <div className="testimonials-area pb-70 bg-fafafb">
            <div className="container-fluid hero-container">
                <div className="row pb-70">
                    <div className="col-lg-6 col-md-12">
                        <div className="about-content our-mission-content">
                            <div className="row content">
                                <h2>{t('tiredSellingTools')}</h2>
                            </div>
                            <div className="row content">
                                <p>{t('workWithCustomers')}</p>
                                <p><Trans t={t}>{'together'}</Trans></p>
                                <p><Trans t={t}>{'globalPartnerNetwork'}</Trans></p>
                                <p><Trans t={t}>{'becomePartner'}</Trans></p>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6 col-md-12">
                        <div className="about-image">
                            <img src={partnerImage} alt="banner" style={{ maxWidth: 800 }} />
                        </div>
                    </div>
                </div>
                <div className="row about-content">
                    <div className="content">
                        <h2>{t('whyPartner')}</h2>
                    </div>
                </div>
                <div className="row about-content pb-70">
                    <div className="content col-lg-6 col-md-12" style={{ maxWidth: 'none' }}>
                        <ul className="content-list partner-benefits">
                            <li><i className="flaticon-tick" /><Trans t={t}>{'differentPartnerTypes'}</Trans></li>
                            <li><i className="flaticon-tick" /><Trans t={t}>{'technicalTraining'}</Trans></li>
                            <li><i className="flaticon-tick" /><Trans t={t}>{'salesTraining'}</Trans></li>
                            <li><i className="flaticon-tick" /><Trans t={t}>{'welcomePackage'}</Trans></li>
                            <li><i className="flaticon-tick" /><Trans t={t}>{'recurringKickbacks'}</Trans></li>
                        </ul>
                    </div>
                    <div className="content col-lg-6 col-md-12" style={{ maxWidth: 'none' }}>
                        <ul className="content-list partner-benefits">
                            <li><i className="flaticon-tick" /><Trans t={t}>{'partnerSupport'}</Trans></li>
                            <li><i className="flaticon-tick" /><Trans t={t}>{'directFeedback'}</Trans></li>
                            <li><i className="flaticon-tick" /><Trans t={t}>{'dedicatedPartnerManager'}</Trans></li>
                            <li><i className="flaticon-tick" /><Trans t={t}>{'freeUseOptions'}</Trans></li>
                            <li><i className="flaticon-tick" /><Trans t={t}>{'networkingOpp'}</Trans></li>
                        </ul>

                    </div>
                </div>
                <div id="bookDemo" className="subscribe-area">
                    <div className="container-fluid hero-container">
                        <div className="row align-items-center">
                            <div className="col-lg-6 col-md-12">
                                <div className="subscribe-image">
                                    <img src={projectstart} alt="subscribe" />
                                </div>
                            </div>

                            <div className="col-lg-6 col-md-12">
                                <div className="subscribe-content">
                                    <h2>{t('becomePartnerToday')}</h2>
                                    <p>{t('getInTouch')}</p>
                                    <Button text={t('getInTouchButton')} icon='flaticon-web' external={true} href='mailto:partner@easylife365.cloud' />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default BecomePartnerContent